<div
  [hidden]="isCurrentValueSet"
  class="view placeholder"
  [attr.e2e-attr]="E2E_ATTRIBUTES.KEY_PAD_INPUT_VIEW_PLACEHOLDER"
>
  {{ placeholder | translate }}
</div>
<div
  [hidden]="!isCurrentValueSet"
  class="view {{ kpType }}"
  [class.display-default]="isDefaultMinValue"
  [attr.e2e-attr]="E2E_ATTRIBUTES.KEY_PAD_INPUT_PLACEHOLDER_USER_KP_TYPE"
>
  {{ value }} {{ measure }}
</div>
